import Seo from '@comp/seo'
import Layout from '@comp/layout'
import TrustBand from '@comp/home/trust-band'
import TryNowSection from '@comp/try/try-now-section'

export default function TryNowPage() {
  return (
    <Layout>
      <Seo
        title="Start free trial | Monofor"
        description="Try Monosign 30 days for free. No credit card required."
        path="/try/now"
      />
      <main className="bg-surface text-ink-primary">
        <TryNowSection />
        <TrustBand />
      </main>
    </Layout>
  )
}
